/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/credit_perc_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 11.415L20.583 16 16 20.586 11.414 16z"/><path pid="1" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zm-24 6L1.354 16 4 13.354v5.292zM16 1.354L18.646 4h-5.293L16 1.354zm0 29.292L13.354 28h5.292L16 30.646zm6.707-13.939L20.414 19l1.543 1.543a.999.999 0 11-1.414 1.414L19 20.414l-2.293 2.293a.997.997 0 01-1.414 0L13 20.414l-1.543 1.543a.997.997 0 01-1.414 0 .999.999 0 010-1.414L11.586 19l-2.293-2.293a.999.999 0 010-1.414L11.586 13l-1.543-1.543a.999.999 0 111.414-1.414L13 11.586l2.293-2.293a.999.999 0 011.414 0L19 11.586l1.544-1.543a.999.999 0 111.414 1.414L20.414 13l2.293 2.293a.999.999 0 010 1.414zM28 13.353L30.646 16 28 18.646v-5.293z"/>'
  }
})
